<template>
	<span class="text-primary">
		<i class="fa fa-download fa-lg icon-button" title="Download" @click.stop="downloadAnexo()"></i>
	</span>
</template>

<script>
export default {
	props: {
		finalizacaoAnexo: {
			type: Object,
			default: () => ({})
		},

		finalizacoesServicos: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},

	methods: {
		downloadAnexo() {
			this.$store.dispatch('addRequest')
			this.finalizacoesServicos
				.obterFinalizacaoAnexo(this.finalizacaoAnexo.finalizacaoAnexoId)
				.then(response => {
					if (response) {
						if (response.type === 'application/json') {
							this.$toast.error(
								'Erro ao realizar download do anexo!!!',
								'ERROR',
								this.$toastConfig.error
							)
						} else {
							this.$download(
								response,
								this.finalizacaoAnexo.nomeArquivoOriginal
							)
						}
					}
					this.$store.dispatch('removeRequest')
				})
		}
	}
}
</script>
